import { Svg, Rect } from "react-native-svg";

const UnChecked = (props) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <Rect x="1" y="1" width="22" height="22" rx="2" stroke="#888C9C" strokeWidth="2" />
  </Svg>
);

export default UnChecked;
